import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import PemohonDashboard from "@/pages/PemohonDashboard";
import FormWizard from "@/pages/FormWizard";
import PreviewPDF from "@/pages/PreviewPDF";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminKanim from "@/pages/AdminKanim";
import AdminForms from "@/pages/AdminForms";

const RequireAdmin = ({ children }) => {
  const token = localStorage.getItem("simpa_token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pemohon" element={<PemohonDashboard />} />
          <Route path="/formulir/:formId" element={<FormWizard />} />
          <Route path="/preview/:submissionId" element={<PreviewPDF />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/admin/kanim" element={<RequireAdmin><AdminKanim /></RequireAdmin>} />
          <Route path="/admin/formulir" element={<RequireAdmin><AdminForms /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
